// À importer AVANT prismjs : sans ce drapeau, Prism colorerait lui-même tous les
// <code class="language-…"> du DOM au chargement, dans le dos de React
if (typeof window !== 'undefined') {
  window.Prism = window.Prism || {};
  window.Prism.manual = true;
}
